import { TextBox } from "devextreme-react";
import React from "react"
import { CodeTemplates } from "../../../../../Constantes/codeDocumentationTemplates";


function InputWrapper(props){
    const {classes, label} = props;
        return(
            <div className="dx-field">
            <label className={classes.label}>{label}</label> 
                <div style={{width:"100%"}} className="dx-field-value">
                    {props.children}
                </div>
        </div>
        )
    }
    

function BackOfficeForm(props){
const {classes, onChange, dataForm, templateCode} = props;
    return(
       
        <div className={classes.containers} id="documentation-request-form">
             {(templateCode === CodeTemplates.FIRST_DRIVER || templateCode === CodeTemplates.SECOND_DRIVER || templateCode === CodeTemplates.TRAVEL_ABROAD) &&
             <>
            <InputWrapper classes={classes} label={"Cliente"}>
                <TextBox key={"client"} name="client" value={dataForm?.client} onValueChanged={(e) => onChange("client", e.value)} className={classes.controlers} height={25}></TextBox>
           </InputWrapper>
           <div className={classes.input_grid}>
           <InputWrapper classes={classes} label={"Código postal"}>
                <TextBox key={"postalCode"} name="postalCode" value={dataForm?.postalCode} onValueChanged={(e) => onChange("postalCode", e.value)} className={classes.controlers} height={25}></TextBox>
           </InputWrapper>
           <InputWrapper classes={classes} label={"Provincia"}>
                <TextBox key={"province"} name="province" value={dataForm?.province} onValueChanged={(e) => onChange("province", e.value)}  className={classes.controlers} height={25}></TextBox>
            </InputWrapper>
            </div>
           <InputWrapper classes={classes} label={"Dirección"}>
                <TextBox key={"address"} name="address" value={dataForm?.address} onValueChanged={(e) => onChange("address", e.value)} className={classes.controlers} height={25}></TextBox>
           </InputWrapper>
           <InputWrapper classes={classes} label={"Localidad"}>
                <TextBox key={"city"} name="city" value={dataForm?.city} onValueChanged={(e) => onChange("city", e.value)} className={classes.controlers} height={25}></TextBox>
           </InputWrapper>
           </>
            }
           {templateCode === CodeTemplates.RENT && 
            <>
                <InputWrapper classes={classes} label={"Cliente"}>
                    <TextBox key={"client"} name="client" value={dataForm?.client} onValueChanged={(e) => onChange("client", e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
                <InputWrapper classes={classes} label={"CIF"}>
                    <TextBox key={"cif"} name="cif" value={dataForm?.cif} onValueChanged={(e) => onChange("cif", e.value)} className={classes.controlers} height={25}></TextBox>
                </InputWrapper>
       </> }   
        </div>
    )
}

export {BackOfficeForm}
